import React from "react";
import { createRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");

// Preserve pre-rendered SSR content before React's createRoot replaces #root contents.
// Crawlers see this content in the raw HTML. React components use it as a loading/error fallback.
const ssrArticle = rootElement.querySelector('[data-ssr-content]');
if (ssrArticle) {
  window.__SSR_CONTENT__ = {
    path: window.location.pathname,
    html: ssrArticle.outerHTML
  };
}

const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// After React's synchronous initial render, clean up static-only elements.
// These exist outside #root for crawlers; React provides its own footer/navigation.
setTimeout(() => {
  const staticFooter = document.querySelector('[data-static-footer]');
  if (staticFooter) staticFooter.remove();
  document.querySelectorAll('[data-internal-links]').forEach(el => el.remove());
  
  // Clean up static blog schema (React will inject its own via BlogDetailPage)
  // Only remove if we're on a blog post page
  if (window.location.pathname.startsWith('/blog/') && window.location.pathname !== '/blog/') {
    document.querySelectorAll('script[type="application/ld+json"]').forEach(el => {
      // Only remove if it doesn't have data-blog-schema (i.e., it's the static one)
      if (!el.hasAttribute('data-blog-schema')) {
        try {
          const content = JSON.parse(el.textContent);
          if (content['@graph'] && content['@graph'].some(n => n['@type'] === 'BlogPosting')) {
            el.remove();
          }
        } catch (e) {
          // Ignore parse errors
        }
      }
    });
  }
}, 0);
